<template>
  <v-row justify="center">
    <v-dialog
      v-bind:value="showDialog"
      scrollable
      transition="dialog-bottom-transition"
      @input="v => v || hideViewer()"
      @keydown.esc="hideViewer({ dropReceipt: true, cancelBtn: true, autopilot: false })"
      min-width="600px"
    >
      <!-- <template v-slot:activator="{ on }"></template> -->
      <v-card>
        <v-card-title>
          <span>Campaign: {{getCampaign()}}</span>
          <span style="margin-left: 1.5rem">Reference: #{{referenceNumber}}</span>
          <v-chip  style="margin-left: 2.5rem" :color="getColor(status)">{{status}}</v-chip>
            <span style="margin-left: .5rem">
              <v-chip error color="warning">{{ rejectReason }}</v-chip>
            </span>
            <span
              v-if="Object.keys(paymentHistory).length > 0"
              style="margin-left: .5rem"
            >
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    error
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >{{ paymentStatus }}
                  </v-chip>
                </template>
                <span>Payment Date: {{ paymentDate }}</span>
              </v-tooltip>
            </span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-flex md5 class="image-container" style="height: 100vh">
              <v-col cols="12" class="pb-0">
                <v-btn
                  class="topButtons"
                  tile
                  depressed
                  width="100%"
                  :color="imgBtnColor.selected"
                >
                  Receipt
                </v-btn>
              </v-col>
              <div
                class="images"
                id="receipt-image"
                ref="receiptImageContainer"
                v-viewer="{inline: true,button:false,navbar:false,title:false,tooltip:false,fullscreen:false}"
              >
              <img v-if="!receiptImageIsLoading" :src="receiptImageSrc" crossorigin alt="Receipt Image" />
              <div v-else class="w-50">
                <img src="@/assets/loading.svg" alt="Loading">
              </div>
              </div>
            </v-flex>
            <v-flex md7 class="right-content">
              <v-tabs-items v-model="activeTab">
                <v-tab-item>
                  <DeclinePaymentReceiptDetails
                    :showDialog="showDialog"
                    :inspectMode="inspectMode"
                    v-on:hideviewer="hideViewer"
                    ref="receiptDetails"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="yellow darken-1" @click="hideViewer({ dropReceipt: true, cancelBtn: true, autopilot: false })">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "@/store/helpers";
import DeclinePaymentReceiptDetails from "./ReceiptViewer/DeclinePaymentReceiptDetails.vue";
import moment from "moment";

export default {
  components: {
    DeclinePaymentReceiptDetails
  },
  data() {
    return {
      error: "Some Errors!!!",
      activeTab: 0
    };
  },
  props: {
    receiptImageIsLoading: {
      required: true
    },
    receiptImageSrc: {
      required: true
    },
    showDialog: {
      required: true,
      type: Boolean
    },
    inspectMode: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapFields([
      "status",
      "referenceNumber",
      "campaign_fk",
      "rejectReason",
      "paymentHistory",
      "paymentStatus"
    ]),
    ...mapGetters(["selectedDashboard"]),
    imgBtnColor() {
      return this.$vuetify.theme.isDark ? {
          selected: 'grey darken-4',
          unselected: 'grey darken-3'
        } : {
          selected: 'grey lighten-1',
          unselected: 'grey lighten-3'
        };
    },
    paymentDate () {
      return moment(this.paymentHistory.updated_at).format("DD/MM/YYYY")
    }
  },
  methods: {
    ...mapActions(["dropReceipt"]),
    getColor(status) {
      if (status === "Confirmed") return "success";
      else if (status === "Rejected") return "error";
      else if (status === "Pre-Confirmed") return "blue-grey";
      else return "blue-grey";
    },
    hideViewer(options = { dropReceipt: false , cancelBtn : false, autopilot: false }) {
      //clean dropdown list
      this.$store.commit("clearCurrentReceipt");
      this.$emit("hide", { dropReceipt: options.dropReceipt, cancelBtn: options.cancelBtn, autopilot: options.autopilot });
      this.$refs.receiptDetails.editMode = false;
    },
    getCampaign() {
      const campaignName = this.campaign_fk || this.selectedDashboard.campaignId
      return campaignName;
    }
  }
};
</script>
<style>
.topButtons {
  z-index: 12;
}

</style>
